exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#interactionToolbar {\r\n  margin: 0;\r\n  padding: 0.25rem 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: baseline;\r\n}\r\n\r\n#interactionToolbar .buildingBlock {\r\n  margin: 0 0.25rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 1rem;\r\n  color: #333;\r\n  box-shadow: 0 1px 2px #ccc;\r\n}\r\n#interactionToolbar .buildingBlock:hover {\r\n  background: #eee;\r\n  color: #000;\r\n}", ""]);

// exports
